import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-width: 58.75rem;
    padding: 2rem;
    margin: 0 auto;
`